import { formatDeliveryDateDisplay } from './dateHelpers';

/**
 * Kiểm tra xem giá trị có phải là trống không
 */
export const isEmptyValue = (value: any): boolean => {
    return value === null || value === undefined || value === '' || (typeof value === 'string' && value.trim() === '');
};

/**
 * Chuẩn hóa giá trị để hiển thị trong filter dropdown
 * @param value Giá trị cần chuẩn hóa
 * @param type Loại giá trị ('date' hoặc undefined)
 * @returns Chuỗi đã chuẩn hóa
 */
export const normalizeValue = (value: any, type?: 'date') => {
    if (isEmptyValue(value)) return '-';
    if (type === 'date') {
        const formattedDate = formatDeliveryDateDisplay(value);
        return formattedDate ? formattedDate.split(' ')[0] : '-';
    }
    return value.toString();
};

